export default __webpack_public_path__ + "static/media/TUSD.51fbcc87.png";